import { projects } from '@config/projects';
import { THEME_DRAWER_WIDTH } from '@config/theme';
import { Box, Drawer, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { MainLayoutSidebarMenuList } from '@widgets/layout/main-layout/main-layout-sidebar/main-layout-sidebar-menu-list';
import { ProjectSelectorModal } from '@widgets/project-selector/project-selector-modal';
import { useMemo } from 'react';

import { MainLayoutSidebarType } from './types';

export const MainLayoutSidebar: MainLayoutSidebarType = ({
  drawerOpen,
  drawerToggle,
  window,
}) => {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));

  const options = useMemo(
    () =>
      projects.map((project) => ({
        value: project.id,
        label: project.id,
        color: 'text.primary',
        iconSrc: project.iconSrc,
      })), //
    []
  );

  const drawer = (
    <>
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <Box sx={{ display: 'flex', p: 2, mx: 'auto' }}>
          <ProjectSelectorModal options={options} />
        </Box>
      </Box>
      <Box sx={{ px: 2 }}>
        <MainLayoutSidebarMenuList />
      </Box>
    </>
  );

  const container =
    window !== undefined ? () => window.document.body : undefined;

  return (
    <Box
      component="nav"
      sx={{
        height: '100%',
        position: 'sticky',
        top: 0,
        flexShrink: { md: 0 },
        width: matchUpMd ? THEME_DRAWER_WIDTH : 'auto',
      }}
      aria-label="navigation drawer"
    >
      <Drawer
        container={container}
        variant={matchUpMd ? 'persistent' : 'temporary'}
        anchor="left"
        open={drawerOpen}
        onClose={drawerToggle}
        sx={{
          '& .MuiDrawer-paper': {
            width: THEME_DRAWER_WIDTH,
            background: theme.palette.background.default,
            color: theme.palette.text.primary,
            borderRight: 'none',
            position: 'static',
          },
        }}
        ModalProps={{ keepMounted: true }}
        color="inherit"
      >
        {drawer}
      </Drawer>
    </Box>
  );
};
